import type { DesignNode } from '@repo/api-contracts';
import { compose, type Matrix, rotateDeg, scale, translate } from './matrix';

export interface NodeBox {
  readonly widthMm: number;
  readonly heightMm: number;
}

/** 이미지·텍스트의 상자 크기. 그룹은 크기 필드가 없어 null 이다. */
export const nodeBoxOf = (node: DesignNode): NodeBox | null =>
  node.type === 'group' ? null : { widthMm: node.width, heightMm: node.height };

/**
 * 노드 로컬 상자([0,w]×[0,h] mm, 원점 왼쪽 위) → 부모 mm 좌표.
 * 이미지·텍스트: 중심 피벗으로 회전·플립(계약 DESIGN_COORDINATE_SYSTEM.pivot). 그룹: 원점 피벗 회전만.
 */
export const nodeMatrix = (node: DesignNode): Matrix => {
  if (node.type === 'group') return compose(translate(node.x, node.y), rotateDeg(node.rotationDeg));
  const halfW = node.width / 2;
  const halfH = node.height / 2;
  const flip =
    node.type === 'image' ? scale(node.flipX ? -1 : 1, node.flipY ? -1 : 1) : scale(1, 1);
  return compose(
    translate(node.x + halfW, node.y + halfH),
    rotateDeg(node.rotationDeg),
    flip,
    translate(-halfW, -halfH),
  );
};
